<template>
    <div class="bg-white mt-3 p-3 progress-status-view activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-3">
                <button v-b-tooltip.hover :title="$backLabel()" id="cancle-label-btn" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('rpa_tasks') }}</span>
            </div>
        </div>

        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" md="12" class="mt-3">
                        <label class="mb-3" for="input-vendor_id-rpat"><strong>{{ $translate('vendor') }}<span
                                    class="red">*</span></strong></label>
                        <customer-type-ahead v-model="model.vendor_id" id="input-vendor_id-rpat" />
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3" for="input-default_officer-rpat">
                            <strong>
                                {{ $translate('default') }} {{ $translate('officer') }}
                            </strong><span class="red">*</span>
                        </label>
                        <b-form-select class="form-control" id="input-default_officer-rpat" value-field="id"
                            text-field="name" v-model="model.default_driver_id" :options="officers">
                            <template #first>
                                <b-form-select-option :value="null">
                                    {{ $translate('any_officer') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3" for="input-order_type_id-rpat"><strong>{{ $translate('activity_type')
                                }}</strong><span class="red">*</span></label>
                        <b-form-select class="form-control" id="input-order_type_id-rpat" value-field="id"
                            text-field="name" v-model="model.order_type_id" :options="orderTypes">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_type')
                                    }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-original_sender-rpat"><strong>{{ $translate('original_sender')
                                }}</strong><span class="red">*</span></label>
                        <b-form-input class="form-control" id="input-original_sender-rpat" value-field="key"
                            text-field="value" v-model="model.original_sender" :placeholder="$translate('email')"
                            type="email">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3" for="input-bill_payment_to-rpat"><strong>{{ $translate('bill_payment_to')
                                }}</strong><span class="red">*</span></label>
                        <b-form-select class="form-control" id="input-bill_payment_to_id-rpat" value-field="id"
                            text-field="name" v-model="model.bill_payment_to_id" :options="billPaymentToItems">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select')
                                    }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-no_of_days_bill_due-rpat">
                            <strong>{{ $translate('no_of_days_bill_due') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <b-form-input class="form-control" id="input-no_of_days_bill_due-rpat" value-field="key"
                            text-field="value" v-model="model.no_of_days_bill_due" :placeholder="$translate('days')"
                            type="number" :min="1">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3" for="input-notify_users-rpat">
                            <strong>{{ $translate('users_for_notification') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <multiselect id="input-order_type"
                            :placeholder="$translate('select_the_users_for_notification')" v-model="model.notify_users"
                            :options="officers" :searchable="true" :multiple="true" :preserve-search="true"
                            :selectLabel="selectLabel" label="name" track-by="id" :close-on-select="true">

                        </multiselect>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3" for="input-type-rpat"><strong>{{ $translate('type') }}</strong><span
                                class="red">*</span></label>
                        <b-form-select class="form-control" id="input-type-rpat" value-field="key" text-field="value"
                            v-model="model.type" :options="rpa_types">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select')
                                    }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-3">
                        <div class="form-check">
                            <label class="form-check-label lh-base">
                                <input type="checkbox" class="form-check-input top-2" id="is_active-rpat"
                                    v-model="model.is_active" name="is_active-rpat" :value="1"
                                    :unchecked-value="false" />
                                {{ $translate("is_active") }}
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-ext_acc_vendor_id-rpat">
                            <strong>{{ $translate('ext_acc_vendor_id') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <b-form-input class="form-control" id="input-ext_acc_vendor_id-rpat" 
                        v-model="model.ext_acc_vendor_id" :placeholder="$translate('ext_acc_vendor_id')">
                        </b-form-input>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-ext_acc_payable_account-rpat">
                            <strong>{{ $translate('ext_acc_payable_account') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <b-form-input class="form-control" id="input-ext_acc_payable_account-rpat" 
                        v-model="model.ext_acc_payable_account" :placeholder="$translate('ext_acc_payable_account')">
                        </b-form-input>
                    </b-col>
                    
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-ext_acc_item_id-rpat">
                            <strong>{{ $translate('ext_acc_item_id') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <b-form-input class="form-control" id="input-ext_acc_item_id-rpat" 
                        v-model="model.ext_acc_item_id" :placeholder="$translate('ext_acc_item_id')">
                        </b-form-input>
                    </b-col>

                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-ext_acc_tax_item_id-rpat">
                            <strong>{{ $translate('ext_acc_tax_item_id') }}</strong>
                            <span class="red">*</span>
                        </label>
                        <b-form-input class="form-control" id="input-ext_acc_tax_item_id-rpat" 
                        v-model="model.ext_acc_tax_item_id" :placeholder="$translate('ext_acc_tax_item_id')">
                        </b-form-input>
                    </b-col>

                  
                  
                </b-row>
                <b-col md="12" class="mb-2 mt-3 text-center">
                    <b-button id="create-rpa-task-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button id="update-rpa-task-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button id="delete-rpa-task-btn" v-if="!!this.model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $translate('delete_item') }}
                    </b-button>
                    <b-button id="cancel-rpa-task-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">
                        {{ $cancelLabel() }}
                    </b-button>
                </b-col>
            </b-form>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import CustomerTypeAhead from "@/components/CustomerTypeAhead";
import Multiselect from 'vue-multiselect'

export default {
    name: 'RpaTasks-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    components: {
        CustomerTypeAhead,
        Multiselect
    },
    data() {
        return {
            model: {
                id: 0,
                vendor_id: null,
                order_type_id: null,
                default_driver_id: null,
                original_sender: null,
                bill_payment_to_id: null,
                no_of_days_bill_due: null,
                ext_acc_vendor_id: null,
                ext_acc_payable_account: null,
                ext_acc_item_id: null,               
                ext_acc_tax_item_id: null,
                notify_users: [],
                is_active: null,
                type: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        officers() {
            return (this.$store.state.orders.drivers || []).map((x) => ({
                id: x.id,
                name: `${x.first_name} ${x.last_name}`.trim(),
            }));
        },

        billPaymentToItems() {
            console.log('this.$store.state.billPaymentTo.items', this.$store.state.billPaymentTo.items)
            return (this.$store.state.billPaymentTo.items || []).map((x) => ({
                id: x.id,
                name: x.username?.trim(),
            }));
        },

        rpa_types() {
            return this.$rpa_types;
        },

        orderTypes() {
            return this.$store.getters["orderType/activityTypesByPermission"];
        },

        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    watch: {},
    async mounted() {
        this.loading = true
        await this.$store.dispatch("orderType/fetchAll");
        await this.$store.dispatch("orders/fetchDriversNew");
        let obj = {
            query: '',
            filters: {},
            page: 0,
            isforcedReload: true,
        }
        await this.$store.dispatch("billPaymentTo/fetchAll", { ...obj });

        if (this.item.id) {
            this.model = this.item
            if (this.item.notify_users) {
                let selectedNotifyUsers = this.officers.filter(x => this.item.notify_users.some(y => y.id == x.id))
                this.$set(this.model, 'notify_users', selectedNotifyUsers);
            }
        }
        this.loading = false
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }

            console.log('model', model)
            const action = model.id ? 'update' : 'create'
            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
            const path = `rpaTask/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                action,
                                message
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'rpaTask/delete'
            const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_rpa_task')
            const message = `${this.$translate('delete_note')}`
            // const errorMsg = 'Unable to delete Progress Status!'
            const alertMsg = this.$translate('delete_alert')
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
        adjustMultiselectHeight() {

            setTimeout(() => {

                const minHeight = 10;
                const wrappersel = document.querySelector('.multiselect__tags-wrap');
                if (!wrappersel) return;
                const calculatedHeight = minHeight + wrappersel.offsetHeight;
                console.log('wrappersel.style.height', wrappersel.offsetHeight, calculatedHeight)

                // const multiselectEl = document.querySelector('.multiselect');
                const tagsel = document.querySelector('.multiselect__tags');
                if (tagsel) {
                    // multiselectEl.style.height = `${calculatedHeight}px`;
                    tagsel.style.height = `${calculatedHeight}px`;
                }
            }, 200);
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
